<template>
  <div class="app-container">
    <div class="page-header">
      <h3>意见反馈</h3>
    </div>
    <div class="data-table">
      <el-table v-loading="loading" :data="feedbacks" border fit style="width: 100%">
        <el-table-column type="index" width="60" align="center" />
        <el-table-column prop="id" label="编号" width="90" align="center" />
        <el-table-column prop="name" label="姓名" width="140" align="center" />
        <el-table-column prop="phone" label="手机号" width="140" align="center" />
        <el-table-column prop="msg" label="内容" min-width="240" />
        <el-table-column label="图片" min-width="240" align="center">
          <template slot-scope="{row}">
            <div class="images">
              <el-image
                v-for="(img,idx) in parseImages(row.images)"
                :key="idx"
                :src="imageWithCdn(img)"
                :preview-src-list="parseImages(row.images).map(imageWithCdn)"
                fit="cover"
                style="width:60px;height:60px" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="时间" width="180" align="center" />
      </el-table>
    </div>
    <div class="pagination-wrapper">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10,20,50,100]"
        :current-page="pagination.page"
        :page-size="pagination.page_size"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import request from '@/api/interceptor'
import { IMAGE_BASE_URL } from '@/api'
export default {
  name: 'Feedbacks',
  data() {
    return {
      loading: false,
      feedbacks: [],
      total: 0,
      pagination: { page: 1, page_size: 10 }
    }
  },
  created() {
    this.fetchFeedbacks()
  },
  methods: {
    async fetchFeedbacks() {
      try {
        this.loading = true
        const params = { page: this.pagination.page, page_size: this.pagination.page_size }
        const res = await request({ url: '/v1/feedbacks', method: 'get', params })
        const outer = res && res.data ? res.data : res
        const data = outer && outer.data ? outer.data : outer
        const list = Array.isArray(data && data.feedbacks) ? data.feedbacks : []
        const total = Number(data && data.total) || list.length
        this.feedbacks = list
        this.total = total
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(size) {
      this.pagination.page_size = size
      this.pagination.page = 1
      this.fetchFeedbacks()
    },
    handleCurrentChange(page) {
      this.pagination.page = page
      this.fetchFeedbacks()
    },
    parseImages(val) {
      if (!val) return []
      if (Array.isArray(val)) return val
      if (typeof val === 'string') {
        const t = val.trim()
        if (!t) return []
        try {
          const arr = JSON.parse(t)
          return Array.isArray(arr) ? arr : []
        } catch (e) {
          return []
        }
      }
      return []
    },
    imageWithCdn(p) {
      if (!p) return ''
      if (/^https?:\/\//.test(p)) return p
      return IMAGE_BASE_URL + String(p).replace(/^\/+/, '')
    },
    centerHeaderStyle() { return { textAlign: 'center' } },
    centerCellStyle() { return { textAlign: 'center' } }
  }
}
</script>

<style scoped>
.app-container {
  background-color: #f0f2f5;
  padding: 20px;
}
.page-header {
  background: #fff;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 12px;
}
.data-table {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
}
.pagination-wrapper {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
  margin-top: 12px;
  text-align: right;
}
.images {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}
</style>
